import styled from 'styled-components';

const ContainerSelect = styled.div`
	display: flex;
	margin: 0 0 8px 0;
	gap: 16px;
`;

export default ContainerSelect;